//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { ShareActionBarActionType } from '@share/actions/shareActionBarActions';
import { SHARE_ACTIONS, ShareStatusFilterValues } from '@share/constants/shareConstants';
import { IShareActionBar } from '@share/models/shareStateModel';

const initialState: IShareActionBar = {
  searchFilterValue: '',
  statusFilterValue: ShareStatusFilterValues.ALL,
};

export default function ShareActionBarReducer(
    state: IShareActionBar = initialState,
    action: ShareActionBarActionType,
): IShareActionBar {
  switch (action.type) {
    case SHARE_ACTIONS.UPDATE_SEARCH_FILTER_VALUE:
      return {
        ...state,
        searchFilterValue: action.searchFilterValue,
      };
    case SHARE_ACTIONS.UPDATE_STATUS_FILTER_VALUE:
      return {
        ...state,
        statusFilterValue: action.statusFilterValue,
      };
    default:
      return state;
  }
}
